// extracted by css-extract-rspack-plugin
var _1 = "nmnhErdMDeg8jupc";
export { _1 as "closeIcon" }
